var map = {
	"./AdjustIcon.svg": [
		19480,
		19480
	],
	"./AffiliateIcon.svg": [
		17983,
		17983
	],
	"./AirplaneIcon.svg": [
		22972,
		22972
	],
	"./AlertBubbleIcon.svg": [
		84536,
		84536
	],
	"./AlertCircleIcon.svg": [
		38776,
		38776
	],
	"./AlertDiamondIcon.svg": [
		75216,
		75216
	],
	"./AlertTriangleIcon.svg": [
		41516,
		41516
	],
	"./AppExtensionIcon.svg": [
		48660,
		48660
	],
	"./AppsFilledIcon.svg": [
		14132,
		14132
	],
	"./AppsIcon.svg": [
		4223,
		4223
	],
	"./ArchiveIcon.svg": [
		15516,
		15516
	],
	"./ArrowDownIcon.svg": [
		72864,
		72864
	],
	"./ArrowLeftIcon.svg": [
		8483,
		30864
	],
	"./ArrowRightIcon.svg": [
		16568,
		16568
	],
	"./ArrowUpIcon.svg": [
		54536,
		54536
	],
	"./ArrowsInHorizontalIcon.svg": [
		38563,
		38563
	],
	"./ArrowsOutHorizontalFilledIcon.svg": [
		53708,
		53708
	],
	"./ArrowsOutHorizontalIcon.svg": [
		89584,
		89584
	],
	"./AttachmentFilledIcon.svg": [
		89380,
		89380
	],
	"./AttachmentIcon.svg": [
		96076,
		96076
	],
	"./AutomationFilledIcon.svg": [
		26972,
		26972
	],
	"./AutomationIcon.svg": [
		43948,
		43948
	],
	"./BackspaceIcon.svg": [
		24900,
		24900
	],
	"./BankFilledIcon.svg": [
		34400,
		34400
	],
	"./BankIcon.svg": [
		90708,
		90708
	],
	"./BarcodeIcon.svg": [
		16628,
		94248
	],
	"./BillFilledIcon.svg": [
		17344,
		17344
	],
	"./BillIcon.svg": [
		88492,
		88492
	],
	"./BlankFilledIcon.svg": [
		46956,
		46956
	],
	"./BlankIcon.svg": [
		64914,
		64914
	],
	"./BlogIcon.svg": [
		740,
		740
	],
	"./BookIcon.svg": [
		46632,
		46632
	],
	"./BookOpenIcon.svg": [
		67956,
		67956
	],
	"./BugIcon.svg": [
		10424,
		10424
	],
	"./ButtonIcon.svg": [
		21524,
		21524
	],
	"./ButtonPressIcon.svg": [
		15988,
		15988
	],
	"./CalculatorIcon.svg": [
		54404,
		54404
	],
	"./CalendarCheckIcon.svg": [
		23408,
		23408
	],
	"./CalendarIcon.svg": [
		87604,
		87604
	],
	"./CalendarTimeIcon.svg": [
		65408,
		65408
	],
	"./CameraFlipIcon.svg": [
		99724,
		99724
	],
	"./CameraIcon.svg": [
		37588,
		37588
	],
	"./CaretDownIcon.svg": [
		38772,
		38772
	],
	"./CaretUpIcon.svg": [
		36528,
		36528
	],
	"./CartAbandonedFilledIcon.svg": [
		65832,
		65832
	],
	"./CartAbandonedIcon.svg": [
		49888,
		49888
	],
	"./CartDiscountIcon.svg": [
		77300,
		77300
	],
	"./CartDownFilledIcon.svg": [
		25392,
		25392
	],
	"./CartDownIcon.svg": [
		38180,
		38180
	],
	"./CartFilledIcon.svg": [
		19888,
		42268
	],
	"./CartIcon.svg": [
		35268,
		35268
	],
	"./CartSaleIcon.svg": [
		10284,
		10284
	],
	"./CartUpIcon.svg": [
		34084,
		34084
	],
	"./CashDollarFilledIcon.svg": [
		15960,
		15960
	],
	"./CashDollarIcon.svg": [
		77664,
		77664
	],
	"./CashEuroIcon.svg": [
		93136,
		93136
	],
	"./CashPoundIcon.svg": [
		85840,
		85840
	],
	"./CashRupeeIcon.svg": [
		44768,
		44768
	],
	"./CashYenIcon.svg": [
		59060,
		59060
	],
	"./CategoriesIcon.svg": [
		28932,
		28932
	],
	"./ChannelsIcon.svg": [
		49024,
		49024
	],
	"./ChartCohortIcon.svg": [
		8004,
		8004
	],
	"./ChartDonutIcon.svg": [
		20392,
		20392
	],
	"./ChartFunnelIcon.svg": [
		91340,
		91340
	],
	"./ChartHistogramFirstIcon.svg": [
		73532,
		73532
	],
	"./ChartHistogramFirstLastIcon.svg": [
		5340,
		5340
	],
	"./ChartHistogramFlatIcon.svg": [
		35110,
		79872
	],
	"./ChartHistogramFullIcon.svg": [
		4172,
		4172
	],
	"./ChartHistogramGrowthIcon.svg": [
		99536,
		77156
	],
	"./ChartHistogramLastIcon.svg": [
		2004,
		24384
	],
	"./ChartHistogramSecondLastIcon.svg": [
		19264,
		19264
	],
	"./ChartHorizontalIcon.svg": [
		58954,
		58954
	],
	"./ChartLineIcon.svg": [
		94400,
		94400
	],
	"./ChartPopularIcon.svg": [
		29500,
		29500
	],
	"./ChartStackedIcon.svg": [
		11532,
		11532
	],
	"./ChartVerticalFilledIcon.svg": [
		99860,
		99860
	],
	"./ChartVerticalIcon.svg": [
		15264,
		15264
	],
	"./ChatIcon.svg": [
		72252,
		72252
	],
	"./ChatReferralIcon.svg": [
		41028,
		41028
	],
	"./CheckCircleIcon.svg": [
		65695,
		65695
	],
	"./CheckIcon.svg": [
		80180,
		80180
	],
	"./CheckSmallIcon.svg": [
		5704,
		5704
	],
	"./CheckboxIcon.svg": [
		26060,
		26060
	],
	"./ChevronDownIcon.svg": [
		48076,
		48076
	],
	"./ChevronLeftIcon.svg": [
		1404,
		1404
	],
	"./ChevronRightIcon.svg": [
		98912,
		98912
	],
	"./ChevronUpIcon.svg": [
		54856,
		54856
	],
	"./CircleChevronDownIcon.svg": [
		19972,
		19972
	],
	"./CircleChevronLeftIcon.svg": [
		74516,
		74516
	],
	"./CircleChevronRightIcon.svg": [
		57144,
		57144
	],
	"./CircleChevronUpIcon.svg": [
		96680,
		96680
	],
	"./CircleDownIcon.svg": [
		32480,
		32480
	],
	"./CircleLeftIcon.svg": [
		6460,
		6460
	],
	"./CircleRightIcon.svg": [
		84831,
		84831
	],
	"./CircleUpIcon.svg": [
		47660,
		47660
	],
	"./ClipboardCheckFilledIcon.svg": [
		324,
		324
	],
	"./ClipboardCheckIcon.svg": [
		40324,
		40324
	],
	"./ClipboardChecklistIcon.svg": [
		45788,
		45788
	],
	"./ClipboardIcon.svg": [
		9372,
		9372
	],
	"./ClockIcon.svg": [
		80888,
		80888
	],
	"./CodeAddIcon.svg": [
		78224,
		78224
	],
	"./CodeIcon.svg": [
		95884,
		95884
	],
	"./CollectionFeaturedIcon.svg": [
		85624,
		85624
	],
	"./CollectionFilledIcon.svg": [
		82604,
		82604
	],
	"./CollectionIcon.svg": [
		51120,
		51120
	],
	"./CollectionReferenceIcon.svg": [
		21196,
		21196
	],
	"./ColorIcon.svg": [
		93668,
		93668
	],
	"./ColorNoneIcon.svg": [
		20308,
		20308
	],
	"./CompassIcon.svg": [
		94200,
		94200
	],
	"./ComposeIcon.svg": [
		98364,
		98364
	],
	"./ConfettiIcon.svg": [
		28412,
		28412
	],
	"./ConnectIcon.svg": [
		86620,
		86620
	],
	"./ContentFilledIcon.svg": [
		65460,
		65460
	],
	"./ContentIcon.svg": [
		72592,
		72592
	],
	"./ContractFilledIcon.svg": [
		43932,
		43932
	],
	"./ContractIcon.svg": [
		97376,
		97376
	],
	"./CornerPillIcon.svg": [
		37780,
		37780
	],
	"./CornerRoundIcon.svg": [
		74028,
		74028
	],
	"./CornerSquareIcon.svg": [
		26036,
		26036
	],
	"./CreditCardCancelIcon.svg": [
		47584,
		47584
	],
	"./CreditCardIcon.svg": [
		85572,
		85572
	],
	"./CreditCardPercentIcon.svg": [
		79164,
		79164
	],
	"./CreditCardReaderChipIcon.svg": [
		42492,
		42492
	],
	"./CreditCardReaderIcon.svg": [
		15820,
		15820
	],
	"./CreditCardReaderTapIcon.svg": [
		16752,
		16752
	],
	"./CreditCardSecureIcon.svg": [
		21384,
		21384
	],
	"./CreditCardTapChipIcon.svg": [
		63252,
		63252
	],
	"./CurrencyConvertIcon.svg": [
		45216,
		45216
	],
	"./CursorBannerIcon.svg": [
		88596,
		88596
	],
	"./CursorFilledIcon.svg": [
		21476,
		21476
	],
	"./CursorIcon.svg": [
		91348,
		91348
	],
	"./CursorOptionIcon.svg": [
		51844,
		51844
	],
	"./DataPresentationIcon.svg": [
		29448,
		29448
	],
	"./DataTableIcon.svg": [
		5492,
		5492
	],
	"./DatabaseAddIcon.svg": [
		89314,
		89314
	],
	"./DatabaseConnectIcon.svg": [
		74796,
		74796
	],
	"./DatabaseIcon.svg": [
		45984,
		45984
	],
	"./DeleteIcon.svg": [
		56256,
		56256
	],
	"./DeliveryFilledIcon.svg": [
		62212,
		62212
	],
	"./DeliveryIcon.svg": [
		1260,
		1260
	],
	"./DesktopIcon.svg": [
		2424,
		2424
	],
	"./DisabledIcon.svg": [
		7156,
		7156
	],
	"./DiscountCodeIcon.svg": [
		30812,
		30812
	],
	"./DiscountFilledIcon.svg": [
		61544,
		83924
	],
	"./DiscountIcon.svg": [
		68396,
		68396
	],
	"./DnsSettingsIcon.svg": [
		75708,
		75708
	],
	"./DockFloatingIcon.svg": [
		60276,
		60276
	],
	"./DockSideIcon.svg": [
		58452,
		58452
	],
	"./DomainFilledIcon.svg": [
		1276,
		1276
	],
	"./DomainIcon.svg": [
		50132,
		50132
	],
	"./DomainLandingPageIcon.svg": [
		88496,
		88496
	],
	"./DomainNewIcon.svg": [
		41810,
		41810
	],
	"./DomainRedirectIcon.svg": [
		13412,
		13412
	],
	"./DragDropIcon.svg": [
		67900,
		67900
	],
	"./DragHandleIcon.svg": [
		68024,
		68024
	],
	"./DuplicateIcon.svg": [
		50380,
		50380
	],
	"./EditIcon.svg": [
		3312,
		3312
	],
	"./EmailFollowUpIcon.svg": [
		65337,
		65337
	],
	"./EmailIcon.svg": [
		46652,
		46652
	],
	"./EmailNewsletterIcon.svg": [
		27708,
		27708
	],
	"./EnterIcon.svg": [
		58880,
		58880
	],
	"./EnvelopeIcon.svg": [
		7040,
		7040
	],
	"./EnvelopeSoftPackIcon.svg": [
		11764,
		11764
	],
	"./ExchangeIcon.svg": [
		3348,
		3348
	],
	"./ExitIcon.svg": [
		75892,
		75892
	],
	"./ExportIcon.svg": [
		41626,
		41626
	],
	"./ExternalIcon.svg": [
		47576,
		47576
	],
	"./ExternalSmallIcon.svg": [
		73007,
		73007
	],
	"./EyeCheckMarkIcon.svg": [
		18940,
		18940
	],
	"./EyeDropperIcon.svg": [
		64860,
		64860
	],
	"./EyeFirstIcon.svg": [
		69364,
		46984
	],
	"./EyeglassesIcon.svg": [
		72576,
		72576
	],
	"./FaviconIcon.svg": [
		2738,
		2738
	],
	"./FileFilledIcon.svg": [
		25357,
		25357
	],
	"./FileIcon.svg": [
		83908,
		83908
	],
	"./FilterIcon.svg": [
		6852,
		6852
	],
	"./FlagIcon.svg": [
		17760,
		17760
	],
	"./FlowerFilledIcon.svg": [
		15684,
		15684
	],
	"./FlowerIcon.svg": [
		99836,
		99836
	],
	"./FolderAddIcon.svg": [
		33184,
		33184
	],
	"./FolderDownIcon.svg": [
		37760,
		37760
	],
	"./FolderIcon.svg": [
		74588,
		74588
	],
	"./FolderRemoveIcon.svg": [
		10352,
		10352
	],
	"./FolderUpIcon.svg": [
		83216,
		83216
	],
	"./FoodIcon.svg": [
		34447,
		34447
	],
	"./ForkliftIcon.svg": [
		35244,
		35244
	],
	"./FormsIcon.svg": [
		47820,
		47820
	],
	"./GamesIcon.svg": [
		12064,
		12064
	],
	"./GaugeIcon.svg": [
		80907,
		80907
	],
	"./GiftCardFilledIcon.svg": [
		50756,
		50756
	],
	"./GiftCardIcon.svg": [
		65228,
		65228
	],
	"./GlobeAsiaFilledIcon.svg": [
		67512,
		67512
	],
	"./GlobeAsiaIcon.svg": [
		61288,
		61288
	],
	"./GlobeEUFilledIcon.svg": [
		33284,
		33284
	],
	"./GlobeEUIcon.svg": [
		6292,
		6292
	],
	"./GlobeFilledIcon.svg": [
		69200,
		69200
	],
	"./GlobeIcon.svg": [
		28172,
		28172
	],
	"./HashtagDecimalIcon.svg": [
		73551,
		73551
	],
	"./HashtagIcon.svg": [
		62532,
		62532
	],
	"./HeartIcon.svg": [
		55228,
		55228
	],
	"./HideIcon.svg": [
		82652,
		82652
	],
	"./HomeFilledIcon.svg": [
		26760,
		26760
	],
	"./HomeIcon.svg": [
		14760,
		14760
	],
	"./IconsFilledIcon.svg": [
		9732,
		9732
	],
	"./IconsIcon.svg": [
		51972,
		51972
	],
	"./IdentityCardFilledIcon.svg": [
		16972,
		16972
	],
	"./IdentityCardIcon.svg": [
		2000,
		2000
	],
	"./ImageAddIcon.svg": [
		46620,
		46620
	],
	"./ImageAltIcon.svg": [
		47272,
		47272
	],
	"./ImageExploreIcon.svg": [
		47416,
		47416
	],
	"./ImageIcon.svg": [
		79480,
		79480
	],
	"./ImageWithTextOverlayIcon.svg": [
		41876,
		41876
	],
	"./ImagesIcon.svg": [
		72584,
		72584
	],
	"./ImportIcon.svg": [
		90252,
		90252
	],
	"./IncentiveIcon.svg": [
		40452,
		40452
	],
	"./IncomingIcon.svg": [
		84616,
		84616
	],
	"./InfoIcon.svg": [
		91988,
		91988
	],
	"./InventoryFilledIcon.svg": [
		40972,
		40972
	],
	"./InventoryIcon.svg": [
		43048,
		43048
	],
	"./InventoryUpdatedIcon.svg": [
		66036,
		66036
	],
	"./IqIcon.svg": [
		57996,
		57996
	],
	"./KeyIcon.svg": [
		99972,
		99972
	],
	"./KeyboardHideIcon.svg": [
		85900,
		85900
	],
	"./KeyboardIcon.svg": [
		77196,
		99576
	],
	"./LabelPrinterIcon.svg": [
		61896,
		61896
	],
	"./LanguageFilledIcon.svg": [
		28556,
		28556
	],
	"./LanguageIcon.svg": [
		98208,
		98208
	],
	"./LanguageTranslateIcon.svg": [
		26531,
		26531
	],
	"./LayoutBlockIcon.svg": [
		41892,
		41892
	],
	"./LayoutBuyButtonHorizontalIcon.svg": [
		4400,
		4400
	],
	"./LayoutBuyButtonIcon.svg": [
		2920,
		2920
	],
	"./LayoutBuyButtonVerticalIcon.svg": [
		89064,
		89064
	],
	"./LayoutColumn1Icon.svg": [
		15108,
		15108
	],
	"./LayoutColumns2Icon.svg": [
		86356,
		86356
	],
	"./LayoutColumns3Icon.svg": [
		65600,
		65600
	],
	"./LayoutFooterIcon.svg": [
		36720,
		36720
	],
	"./LayoutHeaderIcon.svg": [
		53296,
		53296
	],
	"./LayoutLogoBlockIcon.svg": [
		46396,
		46396
	],
	"./LayoutPopupIcon.svg": [
		63168,
		63168
	],
	"./LayoutRows2Icon.svg": [
		31092,
		31092
	],
	"./LayoutSectionIcon.svg": [
		47928,
		47928
	],
	"./LayoutSidebarLeftIcon.svg": [
		24884,
		24884
	],
	"./LayoutSidebarRightIcon.svg": [
		92300,
		92300
	],
	"./LightbulbIcon.svg": [
		45740,
		45740
	],
	"./LinkIcon.svg": [
		53513,
		53513
	],
	"./ListBulletedFilledIcon.svg": [
		28876,
		28876
	],
	"./ListBulletedIcon.svg": [
		5792,
		5792
	],
	"./ListNumberedIcon.svg": [
		85972,
		85972
	],
	"./LiveFilledIcon.svg": [
		84508,
		84508
	],
	"./LiveIcon.svg": [
		8168,
		8168
	],
	"./LocationFilledIcon.svg": [
		57728,
		57728
	],
	"./LocationIcon.svg": [
		66704,
		66704
	],
	"./LocationNoneIcon.svg": [
		14708,
		14708
	],
	"./LockFilledIcon.svg": [
		9164,
		9164
	],
	"./LockIcon.svg": [
		57164,
		57164
	],
	"./LogoCriteoIcon.svg": [
		3020,
		3020
	],
	"./LogoFacebookIcon.svg": [
		71000,
		71000
	],
	"./LogoGoogleIcon.svg": [
		81076,
		81076
	],
	"./LogoInstagramIcon.svg": [
		57156,
		57156
	],
	"./LogoMetaIcon.svg": [
		86260,
		86260
	],
	"./LogoPinterestIcon.svg": [
		79488,
		79488
	],
	"./LogoSnapchatIcon.svg": [
		42160,
		42160
	],
	"./LogoTiktokIcon.svg": [
		94858,
		94858
	],
	"./LogoTumblrIcon.svg": [
		36855,
		59236
	],
	"./LogoTwitchIcon.svg": [
		76308,
		76308
	],
	"./LogoVimeoIcon.svg": [
		78180,
		78180
	],
	"./LogoXIcon.svg": [
		61000,
		61000
	],
	"./LogoYoutubeIcon.svg": [
		45544,
		67924
	],
	"./MagicIcon.svg": [
		82392,
		82392
	],
	"./MarketsEuroFilledIcon.svg": [
		63420,
		63420
	],
	"./MarketsEuroIcon.svg": [
		2166,
		2166
	],
	"./MarketsFilledIcon.svg": [
		85592,
		7972
	],
	"./MarketsIcon.svg": [
		22748,
		22748
	],
	"./MarketsRupeeFilledIcon.svg": [
		17228,
		17228
	],
	"./MarketsRupeeIcon.svg": [
		59752,
		59752
	],
	"./MarketsYenFilledIcon.svg": [
		62316,
		62316
	],
	"./MarketsYenIcon.svg": [
		58648,
		58648
	],
	"./MaximizeIcon.svg": [
		23892,
		23892
	],
	"./MeasurementSizeIcon.svg": [
		22148,
		22148
	],
	"./MeasurementVolumeIcon.svg": [
		85144,
		85144
	],
	"./MeasurementWeightIcon.svg": [
		64844,
		64844
	],
	"./MediaReceiverIcon.svg": [
		83300,
		83300
	],
	"./MegaphoneFilledIcon.svg": [
		46056,
		46056
	],
	"./MegaphoneIcon.svg": [
		91072,
		91072
	],
	"./MentionIcon.svg": [
		79960,
		79960
	],
	"./MenuHorizontalIcon.svg": [
		92916,
		92916
	],
	"./MenuIcon.svg": [
		72952,
		72952
	],
	"./MenuVerticalIcon.svg": [
		6307,
		6307
	],
	"./MergeIcon.svg": [
		42604,
		42604
	],
	"./MetafieldsFilledIcon.svg": [
		32792,
		32792
	],
	"./MetafieldsIcon.svg": [
		55456,
		55456
	],
	"./MetaobjectFilledIcon.svg": [
		17140,
		17140
	],
	"./MetaobjectIcon.svg": [
		15060,
		15060
	],
	"./MetaobjectReferenceIcon.svg": [
		97840,
		97840
	],
	"./MicrophoneIcon.svg": [
		60312,
		60312
	],
	"./MinimizeIcon.svg": [
		75424,
		75424
	],
	"./MinusCircleIcon.svg": [
		39108,
		39108
	],
	"./MinusIcon.svg": [
		95244,
		95244
	],
	"./MobileIcon.svg": [
		87600,
		87600
	],
	"./MoneyFilledIcon.svg": [
		75420,
		75420
	],
	"./MoneyIcon.svg": [
		39463,
		39463
	],
	"./MoneyNoneIcon.svg": [
		26892,
		26892
	],
	"./NatureIcon.svg": [
		65688,
		88068
	],
	"./NoteAddIcon.svg": [
		7432,
		7432
	],
	"./NoteIcon.svg": [
		10260,
		10260
	],
	"./NotificationFilledIcon.svg": [
		64480,
		64480
	],
	"./NotificationIcon.svg": [
		22436,
		22436
	],
	"./OrderDraftFilledIcon.svg": [
		73132,
		73132
	],
	"./OrderDraftIcon.svg": [
		48912,
		48912
	],
	"./OrderFilledIcon.svg": [
		65152,
		65152
	],
	"./OrderFirstIcon.svg": [
		54328,
		54328
	],
	"./OrderFulfilledIcon.svg": [
		34892,
		34892
	],
	"./OrderIcon.svg": [
		16144,
		16144
	],
	"./OrderRepeatIcon.svg": [
		8552,
		8552
	],
	"./OrderUnfulfilledIcon.svg": [
		11500,
		11500
	],
	"./OrdersStatusIcon.svg": [
		94276,
		94276
	],
	"./OrganizationIcon.svg": [
		92420,
		92420
	],
	"./OutdentIcon.svg": [
		6408,
		6408
	],
	"./OutgoingIcon.svg": [
		82300,
		82300
	],
	"./PackageFilledIcon.svg": [
		39604,
		39604
	],
	"./PackageFulfilledIcon.svg": [
		95348,
		95348
	],
	"./PackageIcon.svg": [
		68316,
		68316
	],
	"./PackageOnHoldIcon.svg": [
		80440,
		80440
	],
	"./PackageReturnedIcon.svg": [
		45880,
		45880
	],
	"./PageAddIcon.svg": [
		35532,
		35532
	],
	"./PageAttachmentIcon.svg": [
		34764,
		12383
	],
	"./PageClockFilledIcon.svg": [
		9620,
		9620
	],
	"./PageClockIcon.svg": [
		92400,
		92400
	],
	"./PageDownIcon.svg": [
		6734,
		51496
	],
	"./PageHeartIcon.svg": [
		71412,
		71412
	],
	"./PageIcon.svg": [
		16380,
		16380
	],
	"./PageReferenceIcon.svg": [
		94824,
		94824
	],
	"./PageRemoveIcon.svg": [
		60040,
		60040
	],
	"./PageUpIcon.svg": [
		38684,
		38684
	],
	"./PaginationEndIcon.svg": [
		21420,
		21420
	],
	"./PaginationStartIcon.svg": [
		24880,
		24880
	],
	"./PaintBrushFlatIcon.svg": [
		7256,
		7256
	],
	"./PaintBrushRoundIcon.svg": [
		80592,
		80592
	],
	"./PaperCheckIcon.svg": [
		83748,
		83748
	],
	"./PasskeyFilledIcon.svg": [
		16196,
		16196
	],
	"./PasskeyIcon.svg": [
		76400,
		76400
	],
	"./PauseCircleIcon.svg": [
		72680,
		72680
	],
	"./PaymentCaptureIcon.svg": [
		29999,
		52380
	],
	"./PaymentFilledIcon.svg": [
		3732,
		26112
	],
	"./PaymentIcon.svg": [
		46520,
		46520
	],
	"./PersonAddIcon.svg": [
		85836,
		85836
	],
	"./PersonExitIcon.svg": [
		28692,
		28692
	],
	"./PersonFilledIcon.svg": [
		97396,
		97396
	],
	"./PersonIcon.svg": [
		4176,
		4176
	],
	"./PersonLockFilledIcon.svg": [
		75356,
		75356
	],
	"./PersonLockIcon.svg": [
		31980,
		54360
	],
	"./PersonRemoveIcon.svg": [
		63856,
		63856
	],
	"./PersonalizedTextIcon.svg": [
		12384,
		34764
	],
	"./PhoneIcon.svg": [
		64587,
		64587
	],
	"./PhoneInIcon.svg": [
		91380,
		91380
	],
	"./PhoneOutIcon.svg": [
		22792,
		22792
	],
	"./PinFilledIcon.svg": [
		72196,
		72196
	],
	"./PinIcon.svg": [
		65372,
		65372
	],
	"./PlanFilledIcon.svg": [
		63652,
		63652
	],
	"./PlanIcon.svg": [
		58444,
		58444
	],
	"./PlayCircleIcon.svg": [
		71652,
		71652
	],
	"./PlayIcon.svg": [
		72564,
		72564
	],
	"./PlusCircleIcon.svg": [
		81580,
		81580
	],
	"./PlusIcon.svg": [
		22964,
		22964
	],
	"./PointOfSaleIcon.svg": [
		6820,
		6820
	],
	"./PriceListFilledIcon.svg": [
		24604,
		24604
	],
	"./PriceListIcon.svg": [
		79128,
		79128
	],
	"./PrintIcon.svg": [
		86628,
		86628
	],
	"./ProductAddIcon.svg": [
		33796,
		33796
	],
	"./ProductCostIcon.svg": [
		46460,
		46460
	],
	"./ProductFilledIcon.svg": [
		11568,
		11568
	],
	"./ProductIcon.svg": [
		9600,
		31980
	],
	"./ProductReferenceIcon.svg": [
		91944,
		91944
	],
	"./ProductRemoveIcon.svg": [
		63828,
		63828
	],
	"./ProductReturnIcon.svg": [
		32020,
		32020
	],
	"./ProfileIcon.svg": [
		4200,
		4200
	],
	"./QuestionCircleIcon.svg": [
		53163,
		75544
	],
	"./ReceiptDollarFilledIcon.svg": [
		51356,
		51356
	],
	"./ReceiptDollarIcon.svg": [
		26412,
		26412
	],
	"./ReceiptEuroFilledIcon.svg": [
		5636,
		5636
	],
	"./ReceiptEuroIcon.svg": [
		7228,
		7228
	],
	"./ReceiptIcon.svg": [
		15488,
		15488
	],
	"./ReceiptPaidIcon.svg": [
		79512,
		79512
	],
	"./ReceiptPoundFilledIcon.svg": [
		73008,
		73008
	],
	"./ReceiptPoundIcon.svg": [
		55268,
		55268
	],
	"./ReceiptRefundIcon.svg": [
		5196,
		5196
	],
	"./ReceiptRupeeFilledIcon.svg": [
		19852,
		19852
	],
	"./ReceiptRupeeIcon.svg": [
		86060,
		86060
	],
	"./ReceiptYenFilledIcon.svg": [
		19388,
		19388
	],
	"./ReceiptYenIcon.svg": [
		29400,
		29400
	],
	"./RedoIcon.svg": [
		42656,
		42656
	],
	"./ReferralCodeIcon.svg": [
		22048,
		22048
	],
	"./RefreshIcon.svg": [
		41248,
		41248
	],
	"./ReplaceIcon.svg": [
		9660,
		9660
	],
	"./ReplayIcon.svg": [
		50980,
		50980
	],
	"./ResetIcon.svg": [
		8392,
		8392
	],
	"./ReturnIcon.svg": [
		81944,
		81944
	],
	"./RewardIcon.svg": [
		56928,
		56928
	],
	"./SandboxIcon.svg": [
		64440,
		64440
	],
	"./SaveIcon.svg": [
		57108,
		57108
	],
	"./SearchIcon.svg": [
		33444,
		33444
	],
	"./SearchListIcon.svg": [
		15492,
		15492
	],
	"./SearchRecentIcon.svg": [
		87816,
		87816
	],
	"./SearchResourceIcon.svg": [
		34188,
		34188
	],
	"./SelectIcon.svg": [
		91232,
		91232
	],
	"./SendIcon.svg": [
		24624,
		24624
	],
	"./SettingsFilledIcon.svg": [
		70884,
		70884
	],
	"./SettingsIcon.svg": [
		12896,
		12896
	],
	"./ShareIcon.svg": [
		71948,
		71948
	],
	"./ShieldCheckMarkIcon.svg": [
		89260,
		89260
	],
	"./ShieldNoneIcon.svg": [
		91128,
		91128
	],
	"./ShieldPendingIcon.svg": [
		50308,
		50308
	],
	"./ShieldPersonIcon.svg": [
		67580,
		67580
	],
	"./ShippingLabelFilledIcon.svg": [
		63348,
		63348
	],
	"./ShippingLabelIcon.svg": [
		58308,
		58308
	],
	"./ShopcodesIcon.svg": [
		99224,
		99224
	],
	"./SidekickIcon.svg": [
		94842,
		17224
	],
	"./SkeletonIcon.svg": [
		62004,
		62004
	],
	"./SlideshowIcon.svg": [
		77704,
		77704
	],
	"./SmileyHappyIcon.svg": [
		53432,
		53432
	],
	"./SmileyJoyIcon.svg": [
		51476,
		51476
	],
	"./SmileyNeutralIcon.svg": [
		13452,
		13452
	],
	"./SmileySadIcon.svg": [
		22804,
		22804
	],
	"./SocialAdIcon.svg": [
		47456,
		47456
	],
	"./SocialPostIcon.svg": [
		14704,
		14704
	],
	"./SortAscendingIcon.svg": [
		28636,
		28636
	],
	"./SortDescendingIcon.svg": [
		73384,
		73384
	],
	"./SortIcon.svg": [
		91804,
		91804
	],
	"./SoundIcon.svg": [
		88441,
		88441
	],
	"./SportsIcon.svg": [
		5104,
		5104
	],
	"./StarFilledIcon.svg": [
		80940,
		80940
	],
	"./StarIcon.svg": [
		7788,
		7788
	],
	"./StatusActiveIcon.svg": [
		50948,
		50948
	],
	"./StatusIcon.svg": [
		84908,
		84908
	],
	"./StopCircleIcon.svg": [
		84004,
		84004
	],
	"./StoreFilledIcon.svg": [
		17396,
		17396
	],
	"./StoreIcon.svg": [
		84704,
		84704
	],
	"./StoreImportIcon.svg": [
		37648,
		37648
	],
	"./StoreManagedIcon.svg": [
		28700,
		28700
	],
	"./StoreOnlineIcon.svg": [
		90988,
		90988
	],
	"./TabletIcon.svg": [
		647,
		647
	],
	"./TargetFilledIcon.svg": [
		22044,
		22044
	],
	"./TargetIcon.svg": [
		21656,
		21656
	],
	"./TaxFilledIcon.svg": [
		68336,
		68336
	],
	"./TaxIcon.svg": [
		1436,
		1436
	],
	"./TeamIcon.svg": [
		31384,
		31384
	],
	"./TextAlignCenterIcon.svg": [
		22184,
		22184
	],
	"./TextAlignLeftIcon.svg": [
		6492,
		6492
	],
	"./TextAlignRightIcon.svg": [
		73744,
		73744
	],
	"./TextBlockIcon.svg": [
		48296,
		48296
	],
	"./TextBoldIcon.svg": [
		65212,
		65212
	],
	"./TextColorIcon.svg": [
		32804,
		32804
	],
	"./TextFontIcon.svg": [
		76480,
		76480
	],
	"./TextGrammarIcon.svg": [
		52981,
		52981
	],
	"./TextIcon.svg": [
		43276,
		43276
	],
	"./TextInColumnsIcon.svg": [
		23216,
		23216
	],
	"./TextInRowsFilledIcon.svg": [
		60872,
		60872
	],
	"./TextInRowsIcon.svg": [
		56004,
		56004
	],
	"./TextIndentIcon.svg": [
		91108,
		91108
	],
	"./TextItalicIcon.svg": [
		41776,
		41776
	],
	"./TextQuoteIcon.svg": [
		37093,
		37093
	],
	"./TextTitleIcon.svg": [
		37148,
		37148
	],
	"./TextUnderlineIcon.svg": [
		93887,
		93887
	],
	"./TextWithImageIcon.svg": [
		47872,
		47872
	],
	"./ThemeEditIcon.svg": [
		80584,
		80584
	],
	"./ThemeIcon.svg": [
		66588,
		66588
	],
	"./ThemeStoreIcon.svg": [
		87333,
		87333
	],
	"./ThemeTemplateIcon.svg": [
		72304,
		72304
	],
	"./ThumbsDownIcon.svg": [
		73764,
		73764
	],
	"./ThumbsUpIcon.svg": [
		940,
		940
	],
	"./TipJarIcon.svg": [
		95248,
		95248
	],
	"./ToggleOffIcon.svg": [
		87044,
		87044
	],
	"./ToggleOnIcon.svg": [
		79200,
		79200
	],
	"./TransactionFeeDollarIcon.svg": [
		81700,
		81700
	],
	"./TransactionFeeEuroIcon.svg": [
		84148,
		84148
	],
	"./TransactionFeePoundIcon.svg": [
		21716,
		21716
	],
	"./TransactionFeeRupeeIcon.svg": [
		93064,
		93064
	],
	"./TransactionFeeYenIcon.svg": [
		24740,
		24740
	],
	"./TransactionIcon.svg": [
		39808,
		39808
	],
	"./TransferIcon.svg": [
		96988,
		96988
	],
	"./TransferInIcon.svg": [
		38883,
		38883
	],
	"./TransferInternalIcon.svg": [
		84862,
		84862
	],
	"./TransferOutIcon.svg": [
		96516,
		96516
	],
	"./UndoIcon.svg": [
		64096,
		64096
	],
	"./UnknownDeviceIcon.svg": [
		81448,
		81448
	],
	"./UploadIcon.svg": [
		72936,
		72936
	],
	"./VariantIcon.svg": [
		61180,
		61180
	],
	"./ViewIcon.svg": [
		87732,
		87732
	],
	"./ViewportNarrowIcon.svg": [
		87404,
		87404
	],
	"./ViewportShortIcon.svg": [
		79956,
		79956
	],
	"./ViewportTallIcon.svg": [
		66836,
		66836
	],
	"./ViewportWideIcon.svg": [
		33340,
		33340
	],
	"./WalletFilledIcon.svg": [
		5604,
		5604
	],
	"./WalletIcon.svg": [
		33272,
		33272
	],
	"./WandIcon.svg": [
		76148,
		76148
	],
	"./WatchIcon.svg": [
		63480,
		63480
	],
	"./WifiIcon.svg": [
		26520,
		26520
	],
	"./WorkFilledIcon.svg": [
		14168,
		14168
	],
	"./WorkIcon.svg": [
		23108,
		45488
	],
	"./WrenchIcon.svg": [
		93580,
		93580
	],
	"./XCircleIcon.svg": [
		72152,
		72152
	],
	"./XIcon.svg": [
		77824,
		77824
	],
	"./XSmallIcon.svg": [
		14828,
		14828
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 67048;
module.exports = webpackAsyncContext;